export const enum WEB_LOCALES {
  RU = 'RU',
  KG = 'KG',
  ENG = 'ENG',
  CN = 'CN',
}

export enum ORGANIZATION {
  ORG_ID_KEY = 'orgReferenceId',
}
